export const IMAGE_SPECS = {
	'pharmacy-icon': 'Tamaño: 84px x 84px - Peso máximo 10kb',
	'pharmacy-photo': 'Tamaño: 500px x 300px - Peso máximo 300kb',
	'footer-logo': 'Tamaño: 250px x 81px - Peso máximo: 150 kb',
	'header-logo':'Tamaño: 250px x 81px - Peso máximo: 150 kb',
	'icon-and-favicon': 'Tamaño: 84px x 84px - Peso máximo 10kb',
	'favicon': 'Tamaño: 84px x 84px - Peso máximo 10kb',	
};
